<template>
  <div
    class="notification-dropdown"
  >
    <button
      class="notification-button"
      @click="toggleDropdown()"
    >
      <b-icon
        style="height: 40px; width: 22px; color: #3A3A3A;color:red;"
        icon="cart"
        aria-hidden="true"
        class="white-icon"
      />
      <span
        v-if="getTotalItemsArticleCart > 0"
        class="cart-counter"
      >{{ getTotalItemsArticleCart }}</span>
    </button>
    <div
      v-show="showDropdown"
      ref="dropdown"
      v-click-outside="closeCart"
      class="dropdown-content"
      style="padding:7px;"
    >
      <div style="display: flex; justify-content: space-between; flex-direction: column;">
        <h1 class="notification-title">
          {{ $t("MaterialVariantCart") }}
        </h1>
      </div>
      <div
        style="text-decoration: none; color: black; z-index: 10"
      >
        <LoadingWrapperSpinner
          request-id="loadArticlesInCart"
          :response-data="getArticlesInCart"
        >

          <ul class="notification-list">
            <li
              v-for="(item, index) in getArticlesInCart"
              :key="item.id"
              class="notification-item"
              style="width: 100%;"
            >

              <div
                v-show="showDropdown"
                ref="dropdown"
                class="notification-message router-link-wrapper"
                style="width: 100%; z-index: 100;display:flex;gap:10px;align-items:center;"
                @click="goToCartTab"
              >
                {{ getTotalItemsArticleCart - (pageNumberFilter - 1) * pageSize - index }}.
                <div
                  class="notification-text"
                >
                  <div style="display: flex; gap: 5%; align-items: center; width: 100%;">
                    <div style="width: 100%;">
                      <span style="padding-bottom: 10px;">{{ $t('ArticleNumber') }}</span>
                      <span style="font-weight: 700;">{{ item.articleNumber || item.orderedArticleNumber }}</span>
                    </div>
                  </div>
                  <div class="price">
                    <span style="padding-bottom: 15px;font-weight: 700;">{{ item.quantity }}</span>
                    <button>{{ $t('OnHold') }}</button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </LoadingWrapperSpinner>

        <div
          style="display:flex;gap:5px; padding-top: 3px;width:98%"
        >
          <button
            class="buttonCancel"
            type="button"
            :disabled="pageNumberFilter == 1"
            @click="previousPage"
          >
            {{ $t('Previous') }}
          </button>
          <button
            class="buttonSubmit"
            type="button"
            @click="nextPage"
          >
            {{ $t('Next') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  components: {
  },
  data() {
    return {
      showDropdown: false,
      pageNumberFilter: 1,
      pageNumber: 1,
      pageSize: 5,
      dropdownOpen: false,
      notiID: null,
      image: {
        zoom: 1,
        imgs: [], // Img Url , string or Array of string
        visible: false,
        index: 0, //
      },
    };
  },
  computed: {
    ...mapGetters([
      'getNotifications',
      'getNotificationCount',
      'getTotalItemsForUsers',
      'getNotificationCountFromBack',
      'notificationCount',
      'getItemsCart',
      'getLoggedInUser',
      'getTotalItemsArticleCart',
      'getArticlesInCart',
    ]),
  },
  watch: {
  },
  directives: {
    clickOutside: {
      mounted(el, binding) {
        el.__ClickOutsideHandler__ = (event) => {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.body.addEventListener('click', el.__ClickOutsideHandler__);
      },
      unmounted(el) {
        document.body.removeEventListener('click', el.__ClickOutsideHandler__);
      },
    },
  },
  mounted() {
  },
  beforeDestroy() {
  },
  // eslint-disable-next-line vue/order-in-components
  methods: {
    ...mapActions([
      'loadNotifications',
      'resetNotificationCount',
      'mark_all_read',
      'mark_read',
      'notifications_number',
      'resetNotificationCountFromBack',
      'loadCartItems',
      'loadArticlesInCart',
    ]),
    goToCartTab() {
      this.closeCart()
      this.$router.push({ path: '/products-in-stock' });
    },
    nextPage() {
      this.pageNumberFilter += 1
      this.loadArticlesInCart({
        storeId: this.getLoggedInUser.storeId,
        orderState: 'Pending',
        pageNumber: this.pageNumberFilter,
        pageSize: this.pageSize,
      });
    },
    previousPage() {
      this.pageNumberFilter -= 1
      this.loadArticlesInCart({
        storeId: this.getLoggedInUser.storeId,
        orderState: 'Pending',
        pageNumber: this.pageNumberFilter,
        pageSize: this.pageSize,
      });
    },
    closeCart() {
      this.showDropdown = false
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
      if (this.showDropdown) {
        this.loadArticlesInCart({
          storeId: this.getLoggedInUser.storeId,
          orderState: 'Pending',
          pageNumber: 1,
          pageSize: this.pageSize,
        });
      }
    },
    dateModified(value) {
      return moment(value).format('DD-MM-YYYY HH:mm');
    },
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.showDropdown = false;
      }
    },
  },
};
</script>

  <style scoped>
  .cart-counter {
    position: absolute;
    top: 0px;
    right: -10px;
    background-color: red;
    color: white;
    border-radius: 50%;
    padding: 0px 5px;
    font-size: 12px;
  }
  .dropdown {
    position: absolute;
    top: 100%;
    right: 21%;
    background-color: white;
    border: 1px solid #ccc;
    padding: 10px;
    z-index: 999;
    /* Add any other desired styles */
  }

  .pagination-container .page-item:not(:first-child):not(:last-child) {
    display: none;
  }

  .notification-dropdown {
    /* position: relative;
    margin-left: 60px; */
    z-index: 9999 !important;
  }

  .notification-button {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  .dropdown-content {
    position: absolute;
    top: 117%;
    right: 0;
    width: 400px;
    max-height: 400px;
    overflow-y: auto;
    background-color: #ffffff;
    border: 1px solid #DCDFE4;
    border-radius: 4px;
    padding: 16px;
  }

  .notification-title {
    font-size: 16px;
    margin-bottom: 16px;
    font-weight: 400;
    border-bottom: 1px solid lightgray;
    padding-bottom: 2%;
  }

  .notification-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    background-color: white;
    border-radius: 10px;
    padding: 5px;
  }

  .notification-item {
    display: flex;
    align-items: center;
    padding: 4px 0;
    border-bottom: 1px solid #eee;
  }

  .notification-icon {
    margin-right: 8px;
    color: #777;
  }

  .notification-text {
    margin: 0;
    text-decoration: none;
    color: inherit;
    display: flex;
    justify-content: space-between;
    width: 100%;
    color: inherit;cursor: pointer;
    height: 70px;
    align-items: center;
  }

  .notification-text span {
    display: flex;
    align-items: center;
    font-size: 15px;
  }

  .notification-time {
    margin: 0;
    color: #999;
    font-size: 12px;
  }

  .see-all-link {
    display: block;
    text-align: left;
    color: #007bff;
    margin-top: 16px;
  }

  .notification-counter {
    position: absolute;
    top: 0;
    right: 4.2%;
    background-color: #ff5252;
    color: #fff;
    font-size: 12px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .price {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0px;
  }

  .price button {
    width: 75px;
    height: 26px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    border: none;
    background: #e5e5e5;
  }

  .router-link-wrapper {
    /* Add your custom styles here */
    /* For example, to remove underline and change color: */
    text-decoration: none;
    color: inherit;
  }
  </style>
